module.exports = __webpack_public_path__ + "static/media/template1.fc052312.png";